import globalActions from '../api/GlobalActions.js'
import globalMutations from '../api/GlobalMutations.js'
import globalGetters from '../api/GlobalGetters.js'

export const state = () => ({
  isStale: true,
  latest_fetch: '',
  type: 'animals',
  canEdit: false,
  canView: false,
  inlineEdit: true,
  modelLabels: {
    single: 'Animal',
    plural: 'Animals'
  },
  filterOverrides: [],
  aliasField: 'name',
  relations: [
    {
      name: 'regions',
      translate: 'regions',
      label: 'Regions',
      value: 'regions',
      storename: 'regions',
      export: false
    },
    {
      name: 'animalTypes',
      translate: 'animalTypes',
      label: 'Animal Types',
      value: 'animalTypes',
      storename: 'animalTypes',
      export: false
    }
  ],
  all: {},
  active: false,
  searchFields: ['name', 'description'],
  bound: {
    name: ''
  },
  filter: {},
  quickFilters: [],
  stub: {},
  include: ''
})

// Mutations ==================

export const mutations = {
  ...globalMutations
}

// Actions ====================

export const actions = {
  ...globalActions
}

// Getters ====================

export const getters = {
  ...globalGetters
}
